import { cache } from 'react';

import { getQueryClient as getQueryClientCore } from '../../../tanstack/entry.js';

/**
 * Shared Tanstack Query Client
 * Used when the same query client is needed by different components or functions
 * This utilizes React cache, therefore it will only work serverside
 *
 * The benefit of this is that you can call getQueryClient() to get a hold of this client anywhere that gets called from a Server Component,
 * including utility functions. The downside is that every time you call dehydrate(getQueryClient()), you serialize the entire queryClient,
 * including queries that have already been serialized before and are unrelated to the current Server Component which is unnecessary overhead.
 */
export const getSharedQueryClient = cache(() => getQueryClientCore());
